import * as React from "react";

import Box from "@mui/material/Box";
import TabPanel from "../../../../../../../components/Tabs/TabPanel.component";
import SimpleTab from "../../../../../../../components/Tabs/SimpleTab";
import ShellPanel from "./Panels/ShellPanel";
import NozzlesPanel from "./Panels/NozzlesPanel";
import Modeling2DPanel from "./Panels/Modeling2DPanel";

const modelingTabs = [
  { label: "Shell", panel: <ShellPanel /> },
  { label: "Nozzles", panel: <NozzlesPanel /> },
  { label: "Attachments", panel: <></> },
  { label: "2D", panel: <Modeling2DPanel /> },
  { label: "Note", panel: <></> },
];

export default function ModelingTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <SimpleTab
          tabs={modelingTabs.map((t) => t.label)}
          value={value}
          setValue={setValue}
          sx={{ fontSize: 16 }}
        />
      </Box>

      {modelingTabs.map((t, i) => {
        return (
          <TabPanel value={value} index={i} key={t.label}>
            {t.panel}
          </TabPanel>
        );
      })}
    </Box>
  );
}
